<template>
  <Modal
    hide-close-button
    :title="title"
  >
    <QCard>
      <QCardSection
        v-if="user.pictureUrl"
        class="row justify-center"
      >
        <span class="full-width q-my-md text-center"> Current picture: </span>
        <img
          class="justify-center"
          height="100px"
          :src="user.pictureUrl"
        />
      </QCardSection>
      <QCardSection>
        <QUploader
          class="q-mt-md full-width"
          hide-upload-btn
          label="Upload new profile picture"
          square
          @added="onFileAdd"
        >
          <template #list="scope">
            <QItemSection
              v-if="scope.files.length"
              class="row full-width items-center"
            >
              <QItemSection
                v-if="scope.files[0].__img"
                class="gt-xs"
              >
                <img
                  height="100px"
                  :src="scope.files[0].__img.src"
                />
              </QItemSection>
            </QItemSection>
          </template>
        </QUploader>
      </QCardSection>

      <QCardActions align="right">
        <QBtn
          v-close-popup
          color="primary"
          flat
          label="Cancel"
          no-caps
          @click="cancel"
        />
        <QBtn
          v-close-popup
          color="black"
          :disable="noFileSelected"
          label="Update picture"
          no-caps
          @click="upload"
        />
      </QCardActions>
    </QCard>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "UploadUserProfilePictureModal",
  components: {
    Modal,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ["cancel", "confirm"],
  data() {
    return {
      file: {
        size: null,
      },
    };
  },
  computed: {
    title() {
      return `Upload Profile Picture for ${this.user.name}`;
    },
    noFileSelected() {
      return !this.file.size;
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
      this.clearFile();
    },
    clearFile() {
      this.file = { size: null };
    },
    onFileAdd([file]) {
      const reader = new FileReader();

      reader.onload = () => {
        const content = reader.result.substr(reader.result.indexOf(",") + 1);

        this.file = {
          name: file.name,
          size: file.size,
          content,
        };
      };

      reader.readAsDataURL(file);
    },
    async upload() {
      try {
        this.$q.loading.show();

        const result = (
          await this.$streemApiAdmin.post("upload", { params: this.file })
        ).data;

        this.$emit("confirm", result.url);
        this.clearFile();
      } catch (error) {
        this.$error("Unable to upload file", error);
      } finally {
        this.$q.loading.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);
}
</style>
